export default __webpack_public_path__ + "static/media/polygon.e248616b.png";